

// // // // import api from '../api/axiosConfig';
// // // // import { Patient, PaginatedPatientsResponse } from '../types';

// // // // const computeAgeInQueue = (createdAt: string): number => {
// // // //   const created = new Date(createdAt).getTime();
// // // //   const now = Date.now();
// // // //   return Math.floor((now - created) / (1000 * 60));
// // // // };

// // // // export const fetchPatients = async (): Promise<PaginatedPatientsResponse> => {
// // // //   const res = await api.CenterworkflowApi.get(
// // // //     '/postworkflow/queues/TELE_DENTIST'
// // // //   );

// // // //   const items = res.data.items || [];

// // // //   const patients: Patient[] = items.map((item: any, index: number) => ({
// // // //     id: item._id,
// // // //     caseId: item.caseId, // ✅ KEY FIX
// // // //     emrNumber: item.case?.child?.emrId,
// // // //     screeningDate: item.createdAt?.split('T')[0],
// // // //     ageInQueue: computeAgeInQueue(item.createdAt),
// // // //   }));

// // // //   return {
// // // //     patients,
// // // //     totalPages: 1,
// // // //     totalRecords: patients.length,
// // // //     currentPage: 1,
// // // //   };
// // // // };





// // // import api from '../api/axiosConfig';
// // // import { Patient, PaginatedPatientsResponse } from '../types';

// // // /**
// // //  * Computes age in queue (minutes)
// // //  */
// // // const computeAgeInQueue = (createdAt: string): number => {
// // //   const created = new Date(createdAt).getTime();
// // //   const now = Date.now();
// // //   return Math.floor((now - created) / (1000 * 60));
// // // };

// // // /**
// // //  * Fetch patients based on logged-in doctor role
// // //  */
// // // export const fetchPatients = async (
// // //   doctorType?: string
// // // ): Promise<PaginatedPatientsResponse> => {
// // //   // 🔹 Decide queue based on role
// // //   const queueRole =
// // //     doctorType === 'Dermatologist'
// // //       ? 'DERMATOLOGY'
// // //       : 'TELE_DENTIST';

// // //   const res = await api.CenterworkflowApi.get(
// // //     `/postworkflow/queues/${queueRole}`
// // //   );

// // //   const items = res.data.items || [];

// // //   const patients: Patient[] = items.map((item: any) => ({
// // //     id: item._id,
// // //     caseId: item.case?._id || item.caseId, // safe fallback
// // //     emrNumber: item.case?.child?.emrId,
// // //     screeningDate: item.createdAt?.split('T')[0],
// // //     ageInQueue: computeAgeInQueue(item.createdAt),
// // //   }));

// // //   return {
// // //     patients,
// // //     totalPages: 1,
// // //     totalRecords: patients.length,
// // //     currentPage: 1,
// // //   };
// // // };






// // import api from '../api/axiosConfig';
// // import { Patient, PaginatedPatientsResponse } from '../types';

// // /**
// //  * Computes age in queue (minutes)
// //  */
// // const computeAgeInQueue = (createdAt: string): number => {
// //   const created = new Date(createdAt).getTime();
// //   const now = Date.now();
// //   return Math.floor((now - created) / (1000 * 60));
// // };

// // /**
// //  * Decide queue role strictly by route
// //  */
// // // const getQueueRoleFromRoute = (): string => {
// // //   const path = window.location.pathname.toLowerCase();

// // //   if (path.includes('/queue/pediatric')) {
// // //     return 'PEDIATRIC_RESIDENT';
// // //   }

// // //   if (path.includes('/queue/dermatology')) {
// // //     return 'DERMATOLOGY';
// // //   }

// // //   if (path.includes('/queue/tele-dentist')) {
// // //     return 'TELE_DENTIST';
// // //   }

// // //   // ✅ Safe fallback
// // //   return 'TELE_DENTIST';
// // // };

// // const getQueueRoleFromRoute = (): string => {
// //   const path = window.location.pathname.toLowerCase();

// //   if (path.includes('/queue/pediatric')) {
// //     return 'PEDIATRIC_RESIDENT';
// //   }

// //   if (path.includes('/queue/dermatology')) {
// //     return 'DERMATOLOGY_Q';
// //   }

// //   if (path.includes('/queue/teledental')) {
// //     return 'TELE_DENTIST';
// //   }

// //   if (path.includes('/queue/tele-final-doctor')) {
// //     return 'TELE_FINAL_DOCTOR';
// //   }

// //   // ❌ NO fallback — force strict routing
// //   throw new Error('Invalid queue route: no matching role found');
// // };

// // /**
// //  * Fetch patients based on active queue route
// //  */
// // export const fetchPatients = async (): Promise<PaginatedPatientsResponse> => {
// //   const queueRole = getQueueRoleFromRoute();

// //   const res = await api.CenterworkflowApi.get(
// //     `/queues/${queueRole}`
// //   );

// //   const items = res.data.items || [];

// //   const patients: Patient[] = items.map((item: any) => ({
// //     id: item._id,
// //     caseId: item.case?._id || item.caseId,
// //     emrNumber: item.case?.child?.emrId,
// //     screeningDate: item.createdAt?.split('T')[0],
// //     ageInQueue: computeAgeInQueue(item.createdAt),
// //   }));

// //   return {
// //     patients,
// //     totalPages: 1,
// //     totalRecords: patients.length,
// //     currentPage: 1,
// //   };
// // };



// // // export const fetchPatients = async (): Promise<PaginatedPatientsResponse> => {
// // //   const queueRole = getQueueRoleFromRoute();

// // //   const res = await api.CenterworkflowApi.get(
// // //     `/queues/${queueRole}`
// // //   );

// // //   // const items = res.data.items || [];
// // // const items = [
// // //   ...(res.data.waiting || []),
// // //   ...(res.data.inProgress || []),
// // //   ...(res.data.done || []),
// // // ];
// // //   // const patients: Patient[] = items.map((item: any) => ({
// // //   //   id: item._id,
// // //   //   caseId: item.case?._id || item.caseId,
// // //   //   emrNumber: item.case?.child?.emrId,
// // //   //   screeningDate: item.createdAt?.split('T')[0],
// // //   //   ageInQueue: computeAgeInQueue(item.createdAt),
// // //   // }));



// // //   const patients: Patient[] = items.map((item: any, index: number) => ({
// // //   id: index + 1,
// // //   caseId: item.sessionId || item.bookingId,
// // //   emrNumber: item.child?.childId || "N/A",
// // //   screeningDate: item.createdAt?.split("T")[0],
// // //   ageInQueue: computeAgeInQueue(item.createdAt),
// // //   status:
// // //     item.state === "WAITING"
// // //       ? "Pending"
// // //       : item.state === "IN_PROGRESS"
// // //       ? "In Progress"
// // //       : "Completed",
// // // }));

// // //   return {
// // //     patients,
// // //     totalPages: 1,
// // //     totalRecords: patients.length,
// // //     currentPage: 1,
// // //   };
// // // };











// import api from "../api/axiosConfig";
// import { Patient, PaginatedPatientsResponse } from "../types";

// const computeAgeInQueue = (createdAt: string): number => {
//   const created = new Date(createdAt).getTime();
//   const now = Date.now();
//   return Math.floor((now - created) / (1000 * 60));
// };

// const getQueueRoleFromRoute = (): string => {
//   const path = window.location.pathname.toLowerCase();

//   if (path.includes("/queue/pediatric")) return "PEDIATRIC_RESIDENT_Q";
//   if (path.includes("/queue/dermatology")) return "DERMATOLOGY_Q";
//   if (path.includes("/queue/teledental")) return "DENTIST_Q";
//   if (path.includes("/queue/tele-final-doctor")) return "FINAL_REVIEW_Q";

//   throw new Error("Invalid queue route");
// };

// // export const fetchPatients = async (): Promise<PaginatedPatientsResponse> => {
// //   const queueRole = getQueueRoleFromRoute();

// //   const res = await api.CenterworkflowApi.get(`/queues/${queueRole}`);

// //   // ✅ NEW API FORMAT
// //   const waiting = res.data.waiting || [];

// //   // const patients: Patient[] = waiting.map((item: any, index: number) => ({
// //   //   id: item._id,
// //   //   caseId: item.bookingId || item.caseId,
// //   //   emrNumber: item.child?.childId || item.child?.emrId,
// //   //   screeningDate: item.workflowDate || item.createdAt?.split("T")[0],
// //   //   ageInQueue: computeAgeInQueue(item.createdAt),
// //   //   serialNo: index + 1,
// //   // }));


// // //   const patients: Patient[] = waiting.map((item: any) => ({
// // //   id: item._id,
// // //   caseId: item.bookingId || item.caseId,
// // //   sessionId: item.sessionId,
// // //   emrNumber: item.child?.childId || item.child?.emrId,
// // //   screeningDate: item.workflowDate || item.createdAt?.split("T")[0],
// // //   ageInQueue: computeAgeInQueue(item.createdAt),
// // // }));

// // const patients: Patient[] = waiting.map((item: any) => ({
// //   id: item._id,
// //   caseId: item.bookingId || item.caseId,
// //   sessionId: item.sessionId,
// //   emrNumber: item.child?.childId || item.child?.emrId,
// //   screeningDate: item.workflowDate || item.createdAt?.split("T")[0],
// //   ageInQueue: computeAgeInQueue(item.createdAt),

// //   // 🔥 ADD THIS
// //   meta: item.meta,
// // }));

// //   return {
// //     patients,
// //     totalPages: 1,
// //     totalRecords: patients.length,
// //     currentPage: 1,
// //   };
// // };


// export const fetchPatients = async (): Promise<PaginatedPatientsResponse> => {
//   const queueRole = getQueueRoleFromRoute();

//   const res = await api.CenterworkflowApi.get(
//     `/queues/${queueRole}`,
//     {
//       headers: {
//         "Cache-Control": "no-cache",
//         Pragma: "no-cache",
//       },
//     }
//   );

//   const waiting = res.data.waiting || [];

//   const patients: Patient[] = waiting.map((item: any) => ({
//     id: item._id,
//     caseId: item.bookingId || item.caseId,
//     sessionId: item.sessionId,
//     emrNumber: item.child?.childId || item.child?.emrId,
//     screeningDate:
//       item.workflowDate ||
//       item.createdAt?.split("T")[0],

//     ageInQueue: computeAgeInQueue(
//       item.createdAt
//     ),

//     meta: item.meta,
//   }));

//   return {
//     patients,
//     totalPages: 1,
//     totalRecords: patients.length,
//     currentPage: 1,
//   };
// };









import api from "../api/axiosConfig";
import {
  Patient,
  PaginatedPatientsResponse,
  QueueClaimReview,
} from "../types";

const computeAgeInQueue = (createdAt?: string): number => {
  if (!createdAt) return 0;

  const created = new Date(createdAt).getTime();

  if (Number.isNaN(created)) return 0;

  const now = Date.now();

  return Math.max(
    0,
    Math.floor((now - created) / (1000 * 60))
  );
};

const getQueueRoleFromRoute = (): string => {
  const path = window.location.pathname.toLowerCase();

  if (path.includes("/queue/pediatric")) {
    return "PEDIATRIC_RESIDENT_Q";
  }

  if (path.includes("/queue/dermatology")) {
    return "DERMATOLOGY_Q";
  }

  if (path.includes("/queue/teledental")) {
    return "DENTIST_Q";
  }

  if (path.includes("/queue/tele-final-doctor")) {
    return "FINAL_REVIEW_Q";
  }

  throw new Error("Invalid queue route");
};

const mapQueueItemToPatient = (
  item: any,
  queueId: string
): Patient => {
  return {
    id: item._id,
    queueItemId: item._id,

    queueId,

    caseId:
      item.bookingId ||
      item.caseId ||
      "",

    sessionId:
      item.sessionId ||
      "",

    emrNumber:
      item.child?.childId ||
      item.child?.emrId ||
      "",

    screeningDate:
      item.workflowDate ||
      item.createdAt?.split("T")[0] ||
      "",

    ageInQueue: computeAgeInQueue(
      item.createdAt
    ),

    claimExpiresAt:
      item.claimExpiresAt,

    meta:
      item.meta,
  };
};

export const fetchPatients = async (
  doctorId: string
): Promise<PaginatedPatientsResponse> => {
  if (!doctorId) {
    throw new Error("Doctor ID is missing");
  }

  const queueRole = getQueueRoleFromRoute();

  const res = await api.CenterworkflowApi.get(
    `/queues/${queueRole}`,
    {
      params: {
        doctorId,
      },
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    }
  );

  const waiting = Array.isArray(res.data?.waiting)
    ? res.data.waiting
    : [];

  const patients: Patient[] = waiting.map(
    (item: any) =>
      mapQueueItemToPatient(
        item,
        queueRole
      )
  );

  const myActiveReview: QueueClaimReview | null =
    res.data?.myActiveReview || null;

  return {
    patients,

    totalPages: 1,

    totalRecords:
      patients.length,

    currentPage: 1,

    myActiveReview,
  };
};